module.exports = __webpack_public_path__ + "img/1.07b11786.jpg";